module.exports = __webpack_public_path__ + "static/media/Icon-Back-02.c81e94d4.svg";